import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@ntconsult/aluma-react';
import { folderService } from '../services/folderService';

export function useDeleteFolder() {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation('folders');

  return useMutation({
    mutationFn: (id: string) => folderService.deleteFolder(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['folders'] });
      toast.success({ title: t('toasts.deleteSuccess') });
    },
    onError: () => {
      toast.danger({ title: t('toasts.deleteError') });
    },
  });
}
